import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { nafColor } from '@nafcore/theme';
import { spacing } from '@naf/theme';

export const Group = styled.section`
  border-bottom: 1px solid ${nafColor.neutral.neutral3};
`;

export const HeaderButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${spacing.space12};
  width: 100%;
  padding: ${spacing.space24} 0;
  border: 0;
  background: transparent;
  color: ${nafColor.signature.black};
  cursor: pointer;
  text-align: left;
`;

export const ChevronWrapper = styled.span<{ $isExpanded: boolean }>`
  display: flex;
  align-items: center;
  margin-left: auto;

  svg {
    transition: transform 0.2s ease;

    ${({ $isExpanded }) =>
      $isExpanded &&
      css`
        transform: rotate(180deg);
      `}
  }
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${spacing.space24};
  height: ${spacing.space24};
`;

export const Panel = styled.div<{ $isExpanded: boolean }>`
  padding-bottom: ${spacing.space24};
  ${({ $isExpanded }) =>
    !$isExpanded &&
    css`
      position: absolute !important;
      opacity: 0;
      pointer-events: none;
      visibility: hidden;
      height: 0 !important;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      width: 1px;
    `}
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space12};
  margin-top: ${spacing.space8};
`;
